// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"5e8cd27a","453":"9859be5a"}[chunkId] + ".chunk.js";
};